export default __webpack_public_path__ + "static/media/tour1.24441bdb.PNG";